import { render, staticRenderFns } from "./SupplierInvoicesSummary.vue?vue&type=template&id=6c4088fe&scoped=true&"
import script from "./SupplierInvoicesSummary.vue?vue&type=script&lang=js&"
export * from "./SupplierInvoicesSummary.vue?vue&type=script&lang=js&"
import style0 from "./SupplierInvoicesSummary.vue?vue&type=style&index=0&id=6c4088fe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c4088fe",
  null
  
)

export default component.exports